export default __webpack_public_path__ + "static/media/180.02782b59.jpg";